<template>
  <div
    :class="[
      'absolute z-10 inline-block rounded-md bg-gray-100',
      {
        'left-0 right-0 top-0 bottom-0': fill,
        'animate-pulse': isAnimated,
      },
    ]"
  />
</template>

<script setup lang="ts">
defineProps<{
  fill?: boolean
  isAnimated?: boolean
}>()
</script>
